import AbstractRequestTask from '../AbstractRequestTask';
import Launcher from '../../apa/Launcher';
import Utils from 'src/utils/Utils.js';

class ModalDismissHBOTask extends AbstractRequestTask {
  constructor() {
    super();
    this.params = super.getParams();
    this.user_token = this.params.user_token;
  }

  getMethod() {
    return 'POST';
  }

  getUrl() {
    const http = "https://";
    const url = "oauth-api.clarovideo.net"
    return `${http}${url}/oauth/external/hbo/v1/modal-dismiss?${this.getQueryStringParams()}`;
  }

  getQueryStringParams() {
	  const params = super.getParams();
	  delete params.api_version;
	  delete params.HKS;
	  delete params.format;
	  delete params.user_id;
    delete params.device_name;
    delete params.device_so;
    delete params.user_token;
	  return Utils.buildQueryParams(params);
  }

  getParams() {
    return {
      suppress_permanently: true
    };
  }

  getEncType() {
    return 'application/json';
  }

  getHeaders() {
    return {
      'Authorization': `Bearer ${this.user_token}`,
      'Content-Type': 'application/json'
    };
  }

  isValid(response) {
    if (response && response.errors) return false;
    return true;
  }
}

export default ModalDismissHBOTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/hbo/ModalDismissHBOTask.js